// @flow
import React from 'react'
import I18n from 'i18n-react'

import type { Sort } from '../Types/Sort'

type Props = {
  activeSorts: Array<Sort>,
  id?: string,
  name?: string,
  config: {
    value: string,
    valueLabel?: string,
    label: string,
    desc?: boolean,
  },
}

export default class SortSelectComponent extends React.Component<Props> {

  onChangeOrder = (desc: boolean) => {
    this.props.onSet({ ...this.props.config, desc })
  }

  render = () => {
    const { config, activeSorts } = this.props

    let active = false
    let desc = true
    if (Array.isArray(activeSorts) && activeSorts.filter(s => s.value === config.value).length > 0) {
      active = true
      desc = activeSorts.find(s => s.value === config.value).desc
    } else if (typeof config.desc === 'boolean') {
      desc = !config.desc
    }

    return (
      <div className='cursor-pointer'  onClick={() => { this.onChangeOrder(!desc) }}>
        <span>
          {I18n.translate(`sort.${config.label}.${config.valueLabel || config.value}`)}&nbsp;
        </span>
        <span>
          {!desc
            ? I18n.translate(`sort.values.${config.valueLabel || config.value}.desc`)
            : I18n.translate(`sort.values.${config.valueLabel || config.value}.asc`)
          }
          <button className='btn-sort'>
            {desc
              ? <span className='pfp pfp-sort'/>
              : <span className='pfp pfp-sort'/>
            }
          </button>
        </span>
      </div>
    )
  }
}
